/**
 * Получение видео-треков участников-переговорок, которые реально отрисованы на экране.
 *
 * Goloom аллоцирует `session.slots.current` только для видимых участников
 * (с учётом пагинации grid'а). Нет слота — нет отображения, метрику
 * для такого peer'а собирать не нужно.
 */
import { MediaStreamKind, ParticipantSlot, SlotType } from '@yandex-video-platform/goloom-sdk';

import { goloomSdk } from '../../../../../../shared/features/goloom-sdk';
import type { TranscoderTrackEntry } from '../types';
import { isTranscoderParticipant } from './is-transcoder-participant';

export function getTranscoderVideoTracks(): TranscoderTrackEntry[] {
    const session = goloomSdk.session;
    if (!session) {
        return [];
    }

    const entries: TranscoderTrackEntry[] = [];
    for (const slot of session.slots.current) {
        if (slot.type !== SlotType.PARTICIPANT) {
            continue;
        }
        const participantSlot = slot as ParticipantSlot;
        const { participant, track, mediaStreamKind } = participantSlot;
        if (!participant || !track) {
            continue;
        }
        if (track.kind !== 'video' || mediaStreamKind !== MediaStreamKind.DEVICES) {
            continue;
        }
        if (!isTranscoderParticipant(participant)) {
            continue;
        }
        entries.push({ peerId: participant.userId, track });
    }
    return entries;
}
